var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResizeMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.33341C1 7.96522 1.29848 7.66675 1.66667 7.66675H5.66667C6.03486 7.66675 6.33333 7.96522 6.33333 8.33341V12.3334C6.33333 12.7016 6.03486 13.0001 5.66667 13.0001C5.29848 13.0001 5 12.7016 5 12.3334V9.00008H1.66667C1.29848 9.00008 1 8.7016 1 8.33341Z",
    fill: "#5B6885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33317 1C8.70136 1 8.99984 1.29848 8.99984 1.66667V5H12.3332C12.7014 5 12.9998 5.29848 12.9998 5.66667C12.9998 6.03486 12.7014 6.33333 12.3332 6.33333H8.33317C7.96498 6.33333 7.6665 6.03486 7.6665 5.66667V1.66667C7.6665 1.29848 7.96498 1 8.33317 1Z",
    fill: "#5B6885"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4712 0.528636C13.7316 0.788986 13.7316 1.2111 13.4712 1.47145L8.80458 6.13811C8.54423 6.39846 8.12212 6.39846 7.86177 6.13811C7.60142 5.87776 7.60142 5.45565 7.86177 5.1953L12.5284 0.528636C12.7888 0.268287 13.2109 0.268287 13.4712 0.528636Z",
    fill: "#5B6885"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13799 7.86201C6.39834 8.12236 6.39834 8.54447 6.13799 8.80482L1.47132 13.4715C1.21097 13.7318 0.788864 13.7318 0.528514 13.4715C0.268165 13.2111 0.268165 12.789 0.528514 12.5287L5.19518 7.86201C5.45553 7.60166 5.87764 7.60166 6.13799 7.86201Z",
    fill: "#5B6885"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeMin);
export default __webpack_public_path__ + "static/media/ResizeMin.0bd3070f.svg";
export { ForwardRef as ReactComponent };